import * as React from 'react';
import TransportHelper, {TRANSPORT_TRAIN} from '../../helpers/TransportHelper';

const TRAIN_PATH = 'M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z';
const BUS_PATH = 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z';

const STYLE = {display: 'inline-flex', alignItems: 'center', gap: '4px', fontWeight: 600, whiteSpace: 'nowrap'};

export const TransportIcon = ({transport}) => (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
        <path d={transport === TRANSPORT_TRAIN ? TRAIN_PATH : BUS_PATH}/>
    </svg>
);

// Icon + "Train"/"Bus" label for a single segment; renders nothing for a regular flight.
const SegmentTransport = ({segment, translator, className = ''}) => {
    const transport = TransportHelper.getSegmentTransport(segment);
    if (!transport) {
        return null;
    }

    return (
        <span className={`segment-transport segment-transport--${transport} ${className}`} style={STYLE}>
            <TransportIcon transport={transport}/>
            {translator.trans(transport === TRANSPORT_TRAIN ? 'Train' : 'Bus')}
        </span>
    );
};

export default SegmentTransport;



// WEBPACK FOOTER //
// ./src/components/common/SegmentTransport.js